/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
var isElementInViewport=function(n){var r=n.getBoundingClientRect();var e=window.innerHeight||document.documentElement.clientHeight;var t=window.innerWidth||document.documentElement.clientWidth;var i=r.top<=e&&r.top+r.height>=0;var o=r.left<=t&&r.left+r.width>=0;return i&&o};export{isElementInViewport as i};
//# sourceMappingURL=is-element-in-viewport-c0ddd69a.js.map